export const en = {
  common: {
    meta: {
      title: "Hey Jerry | Your money, clearer and yours.",
    },
    actions: {
      add: "Add",
      cancel: "Cancel",
      close: "Close",
      create: "Create",
      delete: "Delete",
      duplicate: "Duplicate",
      edit: "Edit",
      save: "Save",
      search: "Search",
      clear: "Clear",
      update: "Update",
      view: "View",
      confirm: "Confirm",
      logout: "Logout",
      profile: "Profile",
      open: "Open",
      select: "Select",
      showPassword: "Show password",
      hidePassword: "Hide password",
      unselect: "Unselect",
    },
    labels: {
      account: "Account",
      accounts: "Accounts",
      greeting: "Hey,",
      cycle: "Cycle",
      amount: "Amount",
      balance: "Balance",
      budget: "Budget",
      category: "Category",
      categories: "Categories",
      installment: "Installment",
      installments: "Installments",
      date: "Date",
      description: "Description",
      email: "Email",
      endDate: "End Date",
      firstName: "First Name",
      inflow: "Inflow",
      language: "Language",
      lastName: "Last Name",
      name: "Name",
      count: "Count",
      net: "Net",
      outflow: "Outflow",
      perMonth: "{{amount}}/mo",
      password: "Password",
      snapshot: "Snapshot",
      savings: "Savings",
      startDate: "Start Date",
      currentBalance: "Current balance",
      required: "Required",
      optional: "Optional",
      tag: "Tag",
      tags: "Tags",
      theme: "Theme",
      total: "Total",
      transaction: "Transaction",
      transactions: "Transactions",
      type: "Type",
    },
    unknown: "Unknown",
    untitled: "Untitled",
    states: {
      creating: "Creating...",
      loading: "Loading...",
      redirecting: "Redirecting...",
      saving: "Saving...",
      deleting: "Deleting...",
      signingIn: "Signing in...",
    },
    prompts: {
      closeModal: "Close modal",
      cannotUndo: "This action cannot be undone.",
      deleteAccount: "Are you sure you want to delete this account? This action cannot be undone.",
      deleteBudget: "Are you sure you want to delete this budget? This action cannot be undone.",
      deleteCategory: "Are you sure you want to delete this category? This action cannot be undone.",
      deleteInstallment: "Are you sure you want to delete this installment? This action cannot be undone.",
      deleteSaving: "Are you sure you want to delete this savings goal? This action cannot be undone.",
      deleteTag: "Are you sure you want to delete this tag? This action cannot be undone.",
      deleteTransaction: "Are you sure you want to delete this transaction? This action cannot be undone.",
      fillRequiredFields: "Please fill in all required fields",
      passwordMismatch: "Passwords do not match.",
      pickItemToAdd: "What do you want to create?"
    },
    errors: {
      couldNotCreateItem: "Could not create item",
      createAccount: "Error creating account. Please try again.",
      createMovement: "Failed to create movement.",
      deleteAccount: "Failed to delete account. Please try again.",
      deleteInstallment: "Failed to delete installment. Please try again.",
      deleteCategory: "Failed to delete category. Please try again.",
      deleteSaving: "Failed to delete savings goal. Please try again.",
      deleteTag: "Failed to delete tag. Please try again.",
      destinationMustDiffer: "Destination account must be different from the origin account.",
      generic: "Something went wrong. Please try again.",
      invalidCredentials: "Invalid credentials. Please try again.",
      missingAuthTokenTitle: "Authentication Token Missing",
      missingAuthTokenBody: "You appear to be authenticated but no token is available. Please logout and login again.",
      boundaryTitle: "Something went wrong",
      boundaryBody: "An unexpected error occurred. Reloading the page usually fixes it.",
      reloadPage: "Reload page",
      selectedAccountNotFound: "Selected account not found.",
      selectedDestinationAccountNotFound: "Selected destination account not found.",
      transferDestinationRequired: "Please select a destination account for transfers.",
    },
    createLabels: {
      savingsGoal: "Savings goal",
      savingPockets: "Saving pocket",
    },
    createDescriptions: {
      account: "Bank, card, or cash",
      budget: "Limit for one category",
      category: "Group your expenses",
      installment: "Future or recurring payment",
      saving: "Goal to save",
      savingPockets: "Institution and pocket management",
      tag: "Mark patterns or context",
      transaction: "Income, expense, or transfer",
    },
    filters: {
      accounts: "Accounts",
      allCycles: "All",
      categories: "Categories",
      installment: "Installments",
      currentCycle: "Current",
      customRange: "Custom",
      lastCycle: "Previous",
      savings: "Savings",
      search: "Search",
      tags: "Tags",
      transactions: "Transactions",
    },
    empty: {
      noInstallment: "No Installment",
      noSavings: "No Savings",
      uncategorized: "Uncategorized",
      untagged: "Untagged",
      user: "User",
    },
    periods: {
      thisMonth: "Current",
      lastMonth: "Previous",
      custom: "Custom",
    },
    theme: {
      dark: "Dark",
      light: "Light",
      system: "System",
      shortDark: "D",
      shortLight: "L",
      shortSystem: "S",
    },
    language: {
      english: "English",
      spanish: "Español",
    },
    navigation: {
      primaryNavigation: "Primary navigation",
      userMenu: "Account menu",
      navigate: "Navigate",
      current: "Current: {{label}}",
      chooseDestination: "Choose destination",
      openNavigationMenu: "Open navigation menu",
      closeNavigationMenu: "Close navigation menu",
      mobileNavigation: "Mobile navigation",
      mobileNavigationMenu: "Mobile navigation menu",
      themeMode: "Theme mode",
      languageMode: "Language selector",
      createMenu: "Create menu",
      closeCreateMenu: "Close create menu",
      openCreateMenu: "Open create menu",
      quickTransaction: "Create quick transaction",
    },
    dialogs: {
      confirmAction: "Confirm action",
      confirmDeletion: "Confirm deletion",
    },
    aria: {
      cancelSelection: "Cancel selection",
      close: "Close",
      deleteItem: "Delete {{name}}",
      duplicateTransactions: "Duplicate {{count}} transactions",
      editItem: "Edit {{name}}",
      goToFirstPage: "Go to first page",
      goToSecondPage: "Go to second page",
      openItem: "Open {{name}}",
      selectAllVisible: "Select all visible transactions",
      selectItem: "Select {{name}}",
      unselectItem: "Unselect {{name}}",
      updateTransactions: "Update {{count}} transactions",
      viewItem: "View {{name}}",
      viewTicketFor: "View ticket for {{name}}",
    },
  },
  profile: {
    mcp: {
      eyebrow: "Agent access",
      title: "Connect Jerry",
      description: "Connect an AI agent to read your Hey Jerry financial data. OAuth is the recommended connection method; personal tokens are available for manual setup.",
      oauthTitle: "Connect with OAuth",
      oauthDescription: "Your agent can request access, then you review and approve read-only permissions in Hey Jerry. The agent handles renewal. OAuth setup will appear here when your agent starts the connection.",
      downloadSkill: "Download Hey Jerry skill package · v{{version}}",
      packageLoading: "Loading the agent package…",
      packageError: "The agent package is not available in this environment.",
      manualTitle: "Personal token · manual setup",
      manualDescription: "Use this only for a client without OAuth support. The token grants read access until it expires or you revoke it.",
      label: "Client label",
      labelPlaceholder: "For example, Claude Desktop",
      expiry: "Token validity",
      days: "{{count}} days",
      create: "Create personal token",
      loading: "Loading personal tokens…",
      loadError: "Could not load personal tokens.",
      createError: "Could not create a token. Check your session and try again.",
      revokeError: "Could not revoke this token. Refresh the list and try again.",
      copyError: "Could not copy to the clipboard. Check browser permissions.",
      copied: "Copied",
      secretOnceTitle: "Save this token now",
      secretOnceDescription: "This secret is shown only once. It is cleared from this page when you finish.",
      secretLabel: "Personal token",
      serverUrl: "MCP server URL",
      copyConfig: "Copy client configuration",
      copySecret: "Copy token",
      savedSecret: "I saved the token",
      status: "Status",
      active: "Active",
      revoked: "Revoked",
      expired: "Expired",
      expires: "Expires {{date}}",
      lastAuthentication: "Last authentication: {{date}}",
      never: "Never",
      empty: "No personal tokens yet.",
      revoke: "Revoke",
      revokeTitle: "Revoke {{label}}?",
      revokeBody: "The client will lose access immediately. This cannot be undone.",
    },
    mcpConsent: {
      title: "Review agent access",
      description: "Choose whether to connect this agent to your Hey Jerry account.",
      clientAsks: "This agent is requesting access:",
      permissions: "Requested permissions",
      resourceHost: "Jerry service:",
      returnHost: "Agent return address:",
      readPermission: "Read your financial data in Hey Jerry.",
      renewPermission: "Renew its connection while access remains valid.",
      renewalNote: "You can revoke this connection at any time from Profile. The agent renews access automatically while the grant remains active.",
      approve: "Approve connection",
      deny: "Deny",
      requestMissing: "This connection request is incomplete. Start again from your agent.",
      requestError: "This connection request has expired or cannot be loaded. Start again from your agent.",
      decisionError: "Could not save your choice. Please try again.",
      loginReturnError: "Could not safely save this connection request for sign-in. Return to your agent and start again.",
      backToProfile: "Back to Profile",
      connectionsTitle: "Agent connections",
      connectionsDescription: "Review and revoke OAuth connections. Last authentication does not confirm that an agent completed a query.",
      loading: "Loading agent connections…",
      loadError: "Could not load agent connections.",
      revokeError: "Could not revoke the connection. Refresh the list and try again.",
      revokeTitle: "Revoke {{client}}?",
      revokeBody: "This agent will lose access immediately. It can reconnect after requesting and receiving your approval.",
      revoke: "Revoke connection",
      status: "Status",
      active: "Active",
      revoked: "Revoked",
      expired: "Expired",
      expires: "Expires {{date}}",
      lastAuthentication: "Last authentication: {{date}}",
      scopes: "Access: {{scopes}}",
      never: "Never",
      empty: "No OAuth connections yet.",
    },
    title: "Your profile",
    subtitle: "Data loaded from get user/.",
    refresh: "Refresh profile",
    saveProfile: "Save changes",
    changePassword: "Change password",
    deleteAccount: {
      action: "Delete account",
      sectionTitle: "Danger zone",
      sectionHint: "Anonymize your profile and close all active sessions.",
      confirmTitle: "Delete your account?",
      confirmBody: "This action cannot be undone.",
      anonymizationDetail: "Your name, email, and phone will be anonymized.",
      sessionsDetail: "All sessions will be closed and you will need to sign in again.",
      irreversibleDetail: "Your accounts and transactions will be kept, but you cannot recover access to this account.",
      confirm: "Delete account",
      error: "Could not delete the account. Your session is still active; try again.",
    },
    terms: "Terms and Conditions",
    identity: "Identity",
    preferences: "Preferences",
    accountStatus: "Account status",
    firstNameFallback: "No first name",
    lastNameFallback: "No last name",
    phoneFallback: "No phone",
    dateFallback: "No date",
    active: "Active",
    inactive: "Inactive",
    yes: "Yes",
    no: "No",
    fields: {
      id: "ID",
      email: "Email",
      firstName: "First name",
      lastName: "Last name",
      phone: "Phone",
      language: "Language",
      theme: "Theme",
      isActive: "Account active",
      createdAt: "Created",
      updatedAt: "Updated",
      deletedAt: "Deleted",
    },
    messages: {
      saveSuccess: "Profile updated.",
      saveError: "Could not update profile. Please try again.",
      passwordSuccess: "Password updated.",
      passwordError: "Could not change password. Check your current password.",
    },
    passwordModal: {
      title: "Change password",
      subtitle: "Use your current password to protect this change.",
      oldPassword: "Current password",
      newPassword: "New password",
      submit: "Save password",
      showPassword: "Show password",
      hidePassword: "Hide password",
    },
    csvImport: {
      open: "Import CSV",
      title: "Import transactions from CSV",
      subtitle: "We will review the file first. Nothing is created until you confirm the preview.",
      progress: {
        review: "Step 1 of 2 · Review file",
        confirm: "Step 2 of 2 · Confirm import",
        complete: "Import complete",
      },
      formatTitle: "Required format",
      formatDisclosure: "View required format",
      ruleEncoding: "Use a UTF-8 encoded .csv file.",
      ruleHeaders: "Use exact lowercase headers: date, name, amount, type, account. Optional: category, description, external_id.",
      ruleValues: "Date must be YYYY-MM-DD; amount positive with up to 2 decimals; type must be DEPOSIT or EXPENSE.",
      ruleNames: "account and category must exactly match existing accounts and categories. category can be empty.",
      ruleLimit: "Maximum 5,000 rows and 2 MiB. Do not add columns or repeat headers.",
      selectFile: "Select CSV file",
      fileHint: "Only .csv, up to 2 MiB",
      browse: "Browse",
      preview: "Review CSV",
      confirm: "Confirm import",
      cancel: "Cancel",
      close: "Close",
      previewReady: "File is valid. Review the summary and confirm to create transactions.",
      complete: "Import complete: {{created}} transactions created; {{duplicates}} duplicates skipped.",
      summary: "{{rows}} rows found · {{valid}} valid · {{errors}} with errors",
      rowError: "Line {{line}} · {{field}}: {{message}}",
      errors: { fileType: "Select a .csv file.", fileSize: "File cannot exceed 2 MiB.", preview: "Could not review the CSV.", confirm: "Could not confirm the import." },
    },
    appMode: {
      label: "App mode",
      ariaLabel: "App mode selector",
      simple: {
        label: "Simple Mode",
        description: "Shows essentials for checking and recording your money with fewer visible options.",
        ariaLabel: "Choose Simple Mode: shows essential features and fewer visible options",
      },
      advanced: {
        label: "Advanced Mode",
        description: "Shows additional tools and controls to manage your money in more detail.",
        ariaLabel: "Choose Advanced Mode: shows additional tools and controls",
      },
    },
    status: {
      complete: "Complete",
      inProgress: "In progress",
      needsAttention: "Needs attention",
    },
    fieldState: {
      ready: "Ready",
      missing: "Missing",
    },
    summary: {
      heroNote: "Quiet settings, kept close to hand.",
      profileStrength: "Profile strength",
      memberSince: "Member since",
      lastSync: "Last sync",
      profileEditor: "Profile editor",
      editorHint: "Keep your details current so account context stays clean across the app.",
      unsavedChanges: "You have unsaved changes.",
      synced: "Everything is synced.",
      environment: "Workspace controls",
      preferencesHint: "Language and theme stay restrained here, separate from your personal details.",
      experience: "App level",
      experienceHint: "Sets how many tools and options the app shows across every view.",
      systemSnapshot: "System snapshot",
      accountTimeline: "Account timeline",
      lastUpdated: "Last updated",
    },
  },
  nav: {
    home: "Home",
    planning: "Planning",
    more: "More",
    homeSubtitle: "General overview",
    wrapped: "Monthly recap",
    wrappedSubtitle: "Your month, seen clearly",
    transactions: "Transactions",
    transactionsSubtitle: "Income, expenses, and transfers",
    accounts: "Accounts",
    accountsSubtitle: "Where your money is",
    categories: "Categories",
    categoriesSubtitle: "Where your money went",
    tags: "Tags",
    tagsSubtitle: "Movement patterns",
    savings: "Savings",
    savingsSubtitle: "Your goals",
    savingPockets: "Savings Pocket",
    savingPocketsSubtitle: "Institutions and pockets",
    budget: "Budgets",
    budgetSubtitle: "Spending limits",
    installments: "Installments",
    installmentsSubtitle: "Upcoming payments",
    analytics: "Analytics",
    analyticsSubtitle: "Charts and cashflow patterns",
    profile: "Profile",
    profileSubtitle: "Your account and preferences",
  },
  wrapped: {
    title: "Your monthly recap",
    subtitle: "A clear look at how your money moved",
    historyTitle: "Previous recaps",
    historyEmpty: "There are no months to show yet.",
    unread: "Not viewed",
    loading: "Loading your recap...",
    loadError: "We couldn't load your recap.",
    pending: "We're preparing your recap",
    noTransactions: "You need at least 10 transactions in the month to see your recap",
    noActiveDays: "You need transactions on at least 5 days of the month",
    noReport: "You don't have recaps yet. Your first one arrives early next month",
    previous: "Previous",
    next: "Next",
    done: "Done",
    progress: "Screen {{current}} of {{total}}",
    income: "Income",
    expenses: "Expenses",
    balance: "Balance",
    spentMore: "You spent {{percent}}% more than the previous month.",
    spentLess: "You spent {{percent}}% less than the previous month.",
    spentSame: "You spent the same as the previous month.",
    expenseIncomeRatio: "For every $1 you earned, you spent {{amount}}.",
    primaryVsIncome: "{{category}} absorbed {{percent}}% of your income.",
    categories: "Categories",
    categoriesEmpty: "No category spending this month.",
    recurringCount_one: "This month: {{count}} transaction",
    recurringCount_other: "This month: {{count}} transactions",
    recurringAmount: "Total: {{amount}}",
    averageTicket: "Average ticket: {{amount}}",
    previousMonthCount_one: "Previous month: {{count}} transaction",
    previousMonthCount_other: "Previous month: {{count}} transactions",
    budgetsRespected: "Budgets respected",
    budgetsExceeded: "Budgets exceeded",
    topBudgetsExceeded: "Largest budget overruns",
    budgetsExceededCount_one: "{{count}} of {{total}} budget exceeded",
    budgetsExceededCount_other: "{{count}} of {{total}} budgets exceeded",
    budgetOverage: "{{excess}} over the {{limit}} limit",
    budgetCounterfactualNegative: "Overruns totaled {{excess}}. Even without them, your balance would have been {{balance}}.",
    budgetCounterfactualPositive: "Overruns totaled {{excess}}. Avoiding them would have moved your balance to {{balance}}.",
    deposited: "Set aside this month",
    focusReduce: "Reduce {{category}} by {{amount}} to return to its limit.",
    focusCloseGap: "Your first goal is to close a {{amount}} gap.",
    focusProtectSurplus: "Protect at least {{amount}} of your surplus.",
    focusStillNegative: "Your projected balance would be {{balance}}; you would still need {{gap}} to reach zero.",
    focusPositive: "Your projected balance would be {{balance}}.",
    reviewBudgets: "Review budgets",
    openPeriod: "Open {{period}} recap",
  },
  auth: {
    brand: {
      kicker: "Hey Jerry",
      headline: "Your money, clearer and yours.",
      subheadline: "A simple space to read movements, goals and habits without visual noise.",
      previewKicker: "Finance OS",
      previewHeadline: "Your money,\nin order.",
      previewSubheadline: "Jerry has organized your month. Sign in to see how things are going.",
      previewAlt: "Illustrative HeyJerry preview showing a monthly summary, spending, and a travel goal.",
      previewRemaining: "Left this month",
      previewCycle: "12 days until your statement closes",
      previewSpending: "Spending",
      previewSpendingChange: "+8% vs. August",
      previewGoal: "Goal · Trip",
      previewGoalAmount: "$13,600 of $20,000",
    },
    signIn: {
      title: "Sign in to your account",
      subtitle: "Use your email and password.",
      submit: "Sign In",
      forgotPassword: "Forgot your password?",
      noAccount: "Don't have an account?",
      signUpLink: "Sign Up",
    },
    signUp: {
      title: "Create Account",
      subtitle: "Enter your information to register",
      confirmPassword: "Confirm Password",
      submit: "Create Account",
      hasAccount: "Already have an account?",
      signInLink: "Sign in",
      termsPrefix: "I agree to the",
      termsLink: "Terms and Conditions",
      termsRequired: "You must agree to the Terms and Conditions before creating an account.",
    },
  },
  dashboard: {
    loadError: "Could not load your dashboard.",
    greeting: "Hey, {{name}}",
    subtitle: "Here is how your money looks this month",
    heroPeriod: "this month",
    heroInflow: "Income {{amount}}",
    heroOutflow: "Expenses {{amount}}",
    insightPositiveAllWeeks:
      "You stayed positive all cycle. More came in than went out every week.",
    insightExpenseUp:
      "You are still positive, but spending went up {{percentage}}% vs last cycle.",
    insightPositiveWeeks:
      "Your inflow exceeded your outflow in {{count}} of {{total}} weeks.",
    insightNegativeWeek: "This cycle tipped in {{label}}: more went out than came in there.",
    insightNegativeGeneric: "You are below zero this cycle. Worth checking which spend moved most.",
    controlRate: "Control Rate",
    ofInflowThisCycle: "of inflow this cycle",
    budgetStatus: "Budget Status",
    nearLimit: "near limit",
    allBudgetsOnTrack: "All budgets on track",
    vsPreviousCycle: "vs previous cycle",
    positionTrendTitle: "Position Trend",
    positionTrendSubtitle: "Monthly position trend",
    positionTrendEmpty: "No data available",
    cycleNet: "Cycle net",
    currentWeek: "This week",
    emptyWeeksSummary_one: "{{count}} week without activity · {{weeks}}",
    emptyWeeksSummary_other: "{{count}} weeks without activity · {{weeks}}",
    latest: "Latest",
    loadingActivity: "Loading activity...",
    noRecentActivityFound: "No recent activity found",
    latestActivityAcrossAccounts: "Latest activity across your accounts",
    tableAccount: "Account",
    repeatedTransactionsTitle: "Repeated Transactions",
    loadingRepeatedTransactions: "Loading repeated transactions...",
    noRepeatedTransactionsFound: "No repeated transactions found",
    repeatedTransactionsSubtitle: "Transactions sorted by repetition count",
    transactionCountShort: "tx",
    repeatedCount: "Repeated {{count}} times",
    targetProgressTitle: "Target Progress",
    loadingSavings: "Loading savings...",
    targetProgressSubtitle: "Track your progress toward defined financial targets",
    budgetLineTitle: "Budget Line",
    budgetLineSubtitle: "Budgeted vs spent by category",
    budgetLineEmpty: "No budgets to chart yet.",
    budgeted: "Budgeted",
    spent: "Spent",
    budget: "Budget",
    allocationBreakdownTitle: "Allocation Breakdown",
    allocationBreakdownSubtitle: "Breakdown of outflow by allocation",
    noDataToDisplay: "No data to display",
    groupedSmallCategories: 'Small categories were grouped into "Others" to keep the view readable.',
    othersLabel: "Others",
    categoryVsBudgetTitle: "Category vs Budget",
    spendingInsights: "Spending Insights",
    budgetHealth: "Budget Health",
    expenseConcentration: "Expense Concentration",
    good: "Good",
    overBudget: "Over budget",
    lowShare: "Low share",
    mediumShare: "Medium share",
    dominantShare: "Dominant share",
    loadingHeatmap: "Loading heatmap...",
    noMonthlyCategoryData: "No monthly category data to chart yet.",
    suggested: "Suggested",
    totalMonthlySpending: "Total monthly spending",
    shareOfMonthlySpending: "Share of monthly spending",
    inflowLabel: "Inflow",
    outflowLabel: "Outflow",
    noChartData: "There is not enough activity yet to compare inflow and outflow.",
    breakdownTitle: "Where it went",
    breakdownBody: "Top categories driving your spending this cycle.",
    noBreakdownData: "No spending categories yet for this cycle.",
    activityTitle: "Recent activity",
    activityBody: "Latest money moves, kept short.",
    activityToday: "Today",
    activityYesterday: "Yesterday",
    activityThisWeek: "This week",
    activityEarlier: "Earlier",
    activityTypeInflow: "Inflow",
    activityTypeOutflow: "Outflow",
    noRecentActivity: "No recent activity yet.",
    viewAllActivity: "See all activity",
    customize: "Customize dashboard",
    customizeShort: "Customize",
    customizeDescription: "Choose which panels appear, how they start, and set their order.",
    panelOpenOnLoad: "Open on load",
    showPanel: "Show {{panel}}",
    hidePanel: "Hide {{panel}}",
    movePanelUp: "Move {{panel}} up",
    movePanelDown: "Move {{panel}} down",
    noVisiblePanels: "No dashboard panels are visible. Use Customize dashboard to show one.",
    glanceTitle: "Your cycle at a glance",
    glanceBudgets: "Budgets",
    glanceBudgetUsed: "{{percent}}% used",
    glanceGoal: "Main goal",
    glanceTopCategory: "Biggest spend",
    shareOfSpendingSuffix: "of your spending",
    breakdownOverline: "Categories · {{period}}",
    viewAllRepeated: "View all",
    collapseSection: "Collapse {{section}}",
    expandSection: "Expand {{section}}",
    positionTrendDescribe:
      "Monthly position trend: {{firstMonth}} {{firstValue}}, high {{highMonth}} {{highValue}}, latest {{latestMonth}} {{latestValue}}.",
    positionTrendRole: "chart",
    positionTrendKeyboardHint: "Use the arrow keys to move between months.",
    positionTrendMonthValue: "{{month}}: {{value}}",
    toolbarLabel: "Cycle and customize home",
  },
  accounts: {
    loadError: "Could not load your accounts.",
    title: "Hey, Accounts!",
    subtitle: "Where your money is",
    addFirst: "Add Your First Account",
    largestPosition: "Largest position",
    highestIncomeSource: "Highest income source",
    highestOutflowAccount: "Highest outflow account",
    editTitle: "Edit account",
    createTitle: "Create account",
    editSubtitle: "Update your account information",
    createSubtitle: "Debit, credit, or cash",
    mainSection: "Main",
    customizationSection: "Customization",
    colorLabel: "Color",
    colorHelp: "If you leave this blank, the account type color is used. Selection has a check mark, not color alone.",
    colorsLoading: "Loading colors...",
    colorsLoadError: "Could not load colors.",
    colorNames: { mist: "Mist", sun: "Sun", lilac: "Lilac", lime: "Lime", rose: "Rose", flame: "Flame" },
    logoutAgain: "Logout and Login Again",
    noAccountBalanceYet: "No account balance yet",
    noInflowRecorded: "No inflow recorded",
    noOutflowRecorded: "No outflow recorded",
    totalPosition: "Total Position",
    haveNow: "Positive cycle balances",
    oweNow: "Negative cycle balances",
    balanceCycleTotal: "Total cycle balance",
    balanceToday: "Total balance · today",
    balanceAvailable: "Available balance",
    balanceCycle: "Cycle balance",
    balanceDebt: "Current debt",
    balanceCash: "In your wallet",
    creditDetailsTitle: "Credit details",
    creditDetailsHelp: "Add the billing cycle and payment details for this credit line.",
    creditLimitLabel: "Credit limit",
    creditLimitHelp: "Total amount available on your credit line.",
    billingCycleDayLabel: "Billing cycle day",
    billingCycleDayHelp: "Day of the month when your cycle closes.",
    paymentDueDaysLabel: "Days to pay",
    paymentDueDaysHelp: "Days between the cycle close and the payment due date.",
    accountNameRequired: "Enter an account name.",
    accountTypePlaceholder: "Choose a type",
    accountTypeRequired: "Choose an account type.",
    creditFieldsRequired: "Complete the credit details.",
    billingCycleDayRange: "The billing cycle day must be between 1 and 31.",
    paymentDueDaysRange: "Days to pay must be between 1 and 60.",
    noAccountsFound: "No accounts found",
    emptyStateBody: "Your accounts will show up here. Add one and you can quickly see where your money sits.",
    heroContext: "across your accounts",
    heroCycleNet: "this cycle",
    flowSummary: "Income {{inflow}} • Expenses {{outflow}}",
    insightDominant: "{{name}} holds most of your money",
    insightGrowing: "{{name}} is your main account and it is growing",
    insightWatching: "{{name}} is still your main account, but it moved down this cycle",
    insightLargest: "{{name}} holds the biggest share of your balance",
    dominantHighlight: "It represents {{percent}}% of the total",
    noChanges: "No changes",
    listTitle: "Your accounts",
    noDescription: "No description",
    itemFlowSummary: "Inflow {{inflow}} • Outflow {{outflow}}",
    flowIncome: "Income",
    flowExpense: "Expenses",
    rowAccessibleLabel: "{{name}}, {{type}}, income {{income}}, expenses {{expense}}, balance {{balance}}. {{credit}}",
    creditAccessibleSummary: "Available credit {{available}}. {{usage}}",
    accountMenuLabel: "More options for {{name}}",
    creditUsagePercent: "{{percent}}% of limit",
    creditUsageValueText: "{{percent}}% of the limit used",
    inactiveTitle: "No balance",
    viewAll: "View all",
    accountTypeFallback: "Account",
    sortByLabel: "Sort by",
    sortDirectionLabel: "Direction",
    sortByName: "Name",
    sortByAmount: "Amount",
    sortAscending: "Ascending",
    sortDescending: "Descending",
    tableTitle: "Accounts table",
    countLabel: "{{count}} accounts",
    activity: "activity",
    monthlyNet: "Monthly net",
    activityShare: "Activity share",
    currentMonthlyActivity: "{{percent}}% of current monthly activity",
    availableCredit: "Available credit",
    availableCreditOf: "Available {{available}} of {{limit}}",
    creditUsage: "{{used}} used of {{limit}} total limit",
    creditUsedPercent: "You used {{percent}}%",
    creditCutDate: "Closes {{date}}",
    creditPaymentDate: "Due {{date}}",
    deletionImpact: {
      previewError: "Could not check how many records would be deleted. Please try again.",
      transactions_one: "{{count}} transaction will be deleted",
      transactions_other: "{{count}} transactions will be deleted",
      transfers_one: "{{count}} transfer to this account will be deleted",
      transfers_other: "{{count}} transfers to this account will be deleted",
      installments_one: "{{count}} installment will be deleted",
      installments_other: "{{count}} installments will be deleted",
      importRows_one: "{{count}} imported row will be unlinked",
      importRows_other: "{{count}} imported rows will be unlinked",
    },
  },
  categories: {
    iconsLoading: "Loading icons…",
    iconsLoadError: "Could not load icons.",
    iconPickerTitle: "Choose an icon",
    iconPickerSubtitle: "{{count}} icons · search or browse by group",
    useIcon: "Use this icon",
    searchIcon: "Search icons",
    searchIconPlaceholder: "Search icons: home, coffee, gym…",
    iconGroups: "Icon groups",
    searchResults: "Search results",
    noIcons: "No icons found for “{{query}}”",
    noIconsHint: "Try another word, like “home” or “coffee”, or browse by group.",
    showIcons: "Show all icons",
    iconCount: "{{count}} icons",
    chosenIcon: "Selected: {{name}}",
    noIcon: "No icon · using Other",
    clearIcon: "No icon",
    saveChanges: "Save changes",
    changesSaved: "Changes saved",
    categoryCreated: "Category {{name}} created",
    editSubtitle: "Change the name, color, or icon",
    createSubtitle: "Group your transactions",
    nameLabel: "Name",
    nameRequired: "Give your category a name",
    namePlaceholder: "e.g. Gym, Pets, Coffee",
    previewName: "Your category",
    previewCaption: "How it will look in your categories",
    iconLabel: "Icon",
    principalSection: "Main",
    customizationSection: "Customization",
    colorsLoading: "Loading colors…",
    colorsLoadError: "Could not load colors.",
    noColor: "No color",
    colorHelp: "Choose a color to recognize your category at a glance.",
    saveError: "Could not save the category. Check the details and try again.",
    viewMovements: "View transactions",
    editCategory: "Edit category",
    deleteCategory: "Delete category",

    loadError: "Could not load your categories.",
    title: "Hey, Categories!",
    subtitle: "Here is where your money went",
    loading: "Loading allocations...",
    topSpendingCategory: "Top spending category",
    highestIncomeSource: "Highest income source",
    outflowConcentration: "Outflow concentration",
    outflowConcentrationValue: "{{count}} categories drive 75% of outflow",
    noConcentrationData: "No concentration data yet",
    noAllocationsFound: "No allocations found",
    addFirstAllocation: "Add Your First Allocation",
    heroLabel: "What hit hardest",
    emptyHero: "No spending yet",
    ofSpending: "of spending",
    ofIncome: "of income",
    noSpendingYet: "There is not enough spending yet to read a pattern.",
    insightDominant: "Most of your spending is going to {{name}}",
    insightLeading: "{{name}} took the biggest share of your spending",
    insightSpread: "Your spending is more spread across several categories",
    distributionTitle: "Your spending",
    listTitle: "Categories",
    latestCategoriesSubtitle: "Check your latest categories",
    noDescription: "No description",
    othersLabel: "Others",
    countLabel: "{{count}} categories",
    activeCountPeriodLabel: "{{count}} active categories this period",
    inactiveTitle: "No movement",
    viewAll: "View all",
    emptyStateBody: "Your categories will show up here once spending starts moving.",
  },
  tags: {
    saveChanges: "Save changes",
    changesSaved: "Changes saved",
    tagCreated: "Tag {{name}} created",
    editSubtitle: "Change the name, description, color, or icon",
    createSubtitle: "Label your transactions",
    nameLabel: "Name",
    nameRequired: "Give your tag a name",
    namePlaceholder: "e.g. Fixed, Vacation, Work",
    previewName: "Your tag",
    previewCaption: "How it will look in your tags",
    iconLabel: "Icon",
    principalSection: "Main",
    customizationSection: "Customization",
    colorsLoading: "Loading colors…",
    colorsLoadError: "Could not load colors.",
    noColor: "No color",
    saveError: "Could not save the tag. Check the details and try again.",

    mainTag: "Main tag",
    taggedShare: "of your tagged spending",
    searchPlaceholder: "Search tags",
    yourTags: "Your tags",
    visibleCount: "{{count}} tags",
    showActions: "Tag actions",
    newTag: "New",

    loadError: "Could not load your tags.",
    title: "Hey, Tags!",
    subtitle: "How your money moves",
    segmentAll: "All",
    segmentCurrent: "Current",
    segmentPrevious: "Previous",
    loading: "Loading tags...",
    topSpendingTag: "Top spending tag",
    highestIncomeTag: "Highest income tag",
    outflowConcentration: "Outflow concentration",
    outflowConcentrationValue: "{{count}} tags drive 75% of outflow",
    noConcentrationData: "No concentration data yet",
    heroLabel: "What dominates most",
    heroMovementContext: "in tagged money",
    heroDominantContext: "{{name}} represents {{percent}}% of tagged movement",
    emptyHero: "No pattern yet",
    ofSpending: "of your spending",
    noBehaviorYet: "There is not enough movement yet to read a pattern.",
    insightMsi: "A big share of your spending is tied to installment payments",
    insightRecurring: "Your recurring spending is carrying more weight this cycle",
    insightDominant: "{{name}} represents a big share of tagged movement",
    insightDominantShort: "Tag {{name}} concentrates almost all movement.",
    insightLeading: "{{name}} is setting the strongest pattern this cycle",
    insightSplitRecommendation: "Split {{name}} into more specific tags to see clearer detail.",
    behaviorHighlight: "{{name}} represents {{percent}}% of how you are spending",
    behaviorBalanced: "Your behavior is more spread across several tags",
    distributionTitle: "Distribution by tag",
    summaryTitle: "Tagged expenses",
    untaggedShare: "Plus {{amount}} with no tag at all.",
    transactionsPeriod: "Tag activity",
    periodBalance: "Period balance",
    transactionsList: "Transactions",
    transactionsByCategory: "By category",
    transactionsLoadError: "Could not load transactions.",
    noTransactionsInPeriod: "No transactions in this period.",
    transactionsCount: "{{count}} transactions",
    uncategorized: "Uncategorized",
    listTitle: "Your tags",
    noDescription: "No description",
    countLabel: "{{count}} tags",
    activeCountLabel: "{{count}} tags with movement",
    inactiveTitle: "No movement",
    inactiveCountLabel: "{{count}} tags without movement",
    viewAll: "View all",
    emptyStateTitle: "No tagged movements yet",
    emptyStateBody: "Add tags to your transactions to better understand how your money moves.",
    addFirst: "Create Your First Tag",
  },
  transactions: {
    tableDate: "Date",
    tableMovement: "Movement",
    tableTime: "Time",
    sortNewest: "Sorted by newest date first",
    tableAmount: "Amount",
    tableActions: "Actions",
    rowActions: "Actions for {{name}}",
    showingCount: "{{shown}} of {{total}} movements",
    selectMovement: "Select {{name}}",
    openMovement: "View or edit {{name}}",
    allTransactions: "All",
    pageTitle: "Hey, Transactions!",
    pageSubtitle: "Your recent activity",
    activityTitle: "Recent activity",
    activityBody: "Latest money moves, kept short.",
    refineLabel: "Refine list",
    noStructuredFilters: "Find it fast.",
    activeFiltersCount: "{{count}} filters active",
    filterToggle: "Filters",
    filterAllTypes: "All",
    typeFilterLabel: "Movement type",
    clearAllFilters: "Clear all",
    removeFilter: "Remove {{label}}",
    groupSelectedCount: "{{count}} selected",
    noFilterMatches: "No matches",
    allAccounts: "All",
    allCategories: "All",
    allTags: "All",
    allInstallments: "All",
    allSavingPlans: "All",
    allSavingPockets: "All",
    multiAccountsSelected: "{{count}} accounts",
    multiCategoriesSelected: "{{count}} categories",
    multiTagsSelected: "{{count}} tags",
    multiInstallmentsSelected: "{{count}} installments",
    multiSavingPlansSelected: "{{count}} saving plans",
    multiSavingPocketsSelected: "{{count}} saving pockets",
    filtersLabel: "Search and filter",
    countLabel: "{{count}} transactions",
    emptyStateBody: "No movements matched those filters.",
    heroOutflowContext: "went out this month",
    heroIncome: "Income {{amount}}",
    heroExpenses: "Expenses {{amount}}",
    flowSummary: "Cash flow",
    incomeLabel: "Income",
    expenseLabel: "Expenses",
    insightLargestMovement: "Your largest movement was {{name}}",
    insightLargestIncome: "Largest income: {{name}} · {{amount}}",
    insightLargestExpense: "Largest expense: {{name}} · {{amount}}",
    jerryInsightLabel: "A note from Jerry",
    insightNoIncome: "Largest income: no movements",
    insightNoExpense: "Largest expense: no movements",
    insightRecentExpense: "Your most recent expense was {{name}}",
    insightTodayHeavy: "You spent more than usual today",
    insightIncome: "A meaningful income landed recently",
    insightExpense: "{{name}} was one of the heaviest recent spends",
    insightCalm: "Your spending looks calm this week",
    group: {
      today: "Today",
      yesterday: "Yesterday",
      week: "This week",
      earlier: "Earlier",
    },
    activityTypeInflow: "Inflow",
    activityTypeOutflow: "Outflow",
    activityTypeTransfer: "Transfer",
    viewMore: "See more movements",
    totalInflow: "Total Inflow",
    totalOutflow: "Total Outflow",
    netPosition: "Net Position",
    largestOutflowCategory: "Largest outflow category",
    topInflowAccount: "Top inflow account",
    recurringMovements: "Recurring movements",
    editMovement: "Edit movement",
    recordMovement: "Record movement",
    ticket: "Ticket",
    updateSelected: "Update",
    applyChanges: "Apply the same changes to {{count}} transaction",
    applyChanges_plural: "Apply the same changes to {{count}} transactions",
    selectedCount: "{{count}} selected",
    tapToSelect: "Tap movements to select",
    deleteSelectedPrompt: "Are you sure you want to delete selected transactions? This action cannot be undone.",
    updateSelectedCta: "Update selected",
    selectOneField: "Select at least one field to update.",
    noChange: "No change",
    transactionDate: "Transaction date",
    installment: "Installment",
    savingPlan: "Saving plan",
    savingPocket: "Saving pocket",
    account: "Account",
    sortLabel: "Sort",
    sortDateDesc: "Date ↓",
    sortDateAsc: "Date ↑",
    sortAmountDesc: "Amount ↓",
    sortAmountAsc: "Amount ↑",
    toolbarLabel: "Movement tools",
    movementDetail: "Movement",
    detailFactsLabel: "Movement details",
    noteLabel: "Note",
    receiptLabel: "Receipt",
    deleteTitle: "Delete this movement?",
    deleteBalanceUp: "Your {{account}} balance goes up {{amount}}.",
    deleteBalanceDown: "Your {{account}} balance goes down {{amount}}.",
    deleteBalanceTransfer: "This transfer will stop counting in your balances.",
    deletedToast: "Movement deleted",
    createdToast: "Movement saved",
    undoAction: "Undo",
    deleteFailed: "We could not delete the movement.",
    retry: "Retry",
    loadErrorTitle: "We could not load your movements",
    loadErrorBody: "Check your connection and try again.",
    emptyTitle: "You have no movements yet",
    emptyBody: "Record your first income or expense to start seeing your flow.",
    newMovement: "New movement",
    createMovement: "Create movement",
  },
  savingPockets: {
    title: "Savings Pocket",
    subtitle: "Manage institutions and saving pockets tied to your savings endpoints.",
    creationType: "Choose what to add",
    totalSaved: "Total saved",
    expectedMonthlyReturn: "Expected monthly return",
    activeInstitutions: "Active institutions",
    loading: "Loading savings pocket data...",
    loadError: "Could not load savings pocket data.",
    none: "None",
    addInstitution: "Add institution",
    editInstitution: "Edit institution",
    institutionEditHint: "Update institution name and notes.",
    saveInstitution: "Save institution",
    createInstitution: "Create institution",
    institutionName: "Institution name",
    institutionPlaceholder: "Nubank, Cetes, GBM",
    institution: "Institution",
    institutions: "Institutions",
    description: "Description",
    descriptionPlaceholder: "Optional notes or context",
    addPocket: "Add pocket",
    editPocket: "Edit pocket",
    savePocket: "Save pocket",
    createPocket: "Create pocket",
    pocketName: "Pocket name",
    pocketPlaceholder: "Emergency fund",
    amount: "Amount",
    annualRate: "Annual rate",
    freezeTime: "Freeze time",
    startingDate: "Starting date",
    freezePlaceholder: "30",
    freezePresetDays: "{{count}} days",
    freezePresetOther: "Other",
    days: "days",
    freezeReturn: "Return after freeze",
    finalAmount: "Final amount",
    monthlyReturn: "Monthly return",
    yearlyReturn: "Yearly return",
    unfreezeDate: "Unfreeze date",
    returnAmountAfterFreeze: "Return amount after freeze",
    distributionTitle: "Distribution by institution",
    distributionSubtitle: "See how your money is split across institutions.",
    pockets: "Saving pockets",
    pocketCount: "pockets",
    unifySavings: "Unify savings",
    unifySavingsHint: "Group pockets by institution to review one consolidated total.",
    redesignHint: "Cleaner view to edit, compare, and review each pocket or institution total.",
    nextUnfreeze: "Next unfreeze: {{date}}",
    formHint: "Add a pocket with amount, rate, freeze time, and institution.",
    deleteInstitutionPrompt: "Delete institution {{name}}?",
    deletePocketPrompt: "Delete pocket {{name}}?",
    modalTitle: "Create savings pocket items",
    modalSubtitle: "Use the request fields from institutions and pockets to create them quickly.",
    activeLabel: "Active",
  },
  savings: {
    newGoalSubtitle: "Save for something specific",
    optionalSection: "Optional",
    loadError: "Could not load your savings.",
    title: "Hey, Savings!",
    subtitle: "How your goals are going",
    closestToGoal: "Closest to goal",
    completedGoals: "Completed goals",
    soonestTarget: "Soonest target",
    noSavingsGoalYet: "No savings goal yet",
    noCompletedGoalsYet: "No completed goals yet",
    goalsReachedTarget: "{{count}} goals reached target",
    noTargetDateSet: "No target date set",
    allocatedToTargets: "Saved",
    cycleAllocation: "This cycle",
    activeTargets: "Active goals",
    noTargetsYet: "No financial targets yet",
    createFirstTarget: "Create Your First Target",
    emptyStateBody: "Your goals will show up here. Start with one and let progress do its thing.",
    heroDelta: "+{{amount}} this cycle",
    heroContext: "across {{count}} active goals",
    heroContextCompleted: "{{count}} goals completed",
    insightJapanTrip: "Japan",
    insightNearlyDone: "Only {{percent}} left for {{name}}",
    insightRemaining: "You need {{amount}} more to complete {{name}}",
    insightAllDone: "All your active goals are already done",
    secondarySummary: "{{count}} active goals • {{amount}}/mo",
    activeGoalsTitle: "Your goals",
    goalActionsTitle: "Actions for {{name}}",
    goalActionsHint: "Swipe left or press and hold a goal to edit or delete it.",
    completedSectionTitle: "Completed ({{count}})",
    completedItem: "{{name}} (completed)",
    tableTitle: "Savings table",
    tableSubtitle: "Sorted by highest completion so the nearest goals stay on top.",
    goalsCount: "{{count}} goals",
    goal: "Goal",
    primaryGoal: "Main goal",
    completedGoals_one: "{{count}} goal completed",
    completedGoals_other: "{{count}} goals completed",
    goalTargetDate: "Goal for",
    targetDate: "Target date",
    noTargetDate: "No target date",
    monthlyNeeded: "Need {{amount}} / month",
    monthlyNeededNoDate: "Set a target date to estimate monthly amount",
    saved: "Saved",
    target: "Target",
    of: "of",
    remaining: "Remaining",
    missingAmount: "Missing",
    progress: "Progress",
    statusCompleted: "Completed",
    statusInProgress: "In progress",
    editGoal: "Edit savings goal",
    createGoal: "Create savings goal",
    modalSubtitle: "Set a target and track your progress",
    savingPlanName: "Saving Plan Name",
    savingNamePlaceholder: "e.g., MacBook Pro, Vacation",
    initialAmount: "Initial Amount",
    initialAmountHelp: "Starting balance for this goal",
    targetAmount: "Target Amount",
    targetAmountHelp: "Goal amount you want to reach",
    expectedDate: "Expected Date",
    expectedDateHelp: "When do you plan to reach this goal?",
    descriptionPlaceholder: "What is this goal for? (optional)",
    createGoalAction: "Create goal",
    totalSavedKicker: "Total saved · {{goals}}",
    remainingForGoals: "Left to reach your goals",
    monthlyContributionNeeded: "Monthly contribution to get there on time",
    searchGoal: "Search goal",
    filterToolbarLabel: "Search, filter by status and sort goals",
    filterStatusLabel: "Status: {{value}}",
    filterStatusAria: "Filter goals by status",
    statusFilterAll: "All",
    statusFilterInProgress: "In progress",
    statusFilterCompleted: "Completed",
    sortByLabel: "Sort goals",
    sortDueAsc: "Due ↑",
    sortDueDesc: "Due ↓",
    sortProgressDesc: "Progress ↓",
    sortNameAsc: "Name A–Z",
    sortNameDesc: "Name Z–A",
    listSummary: "{{inProgress}} · {{completed}}",
    inProgressCount: "{{count}} in progress",
    completedShort_one: "{{count}} completed",
    completedShort_other: "{{count}} completed",
    dueDate: "Due {{date}}",
    goalAmountLine: "{{saved}} of {{target}}",
    goalAmountMissingLine: "{{saved}} of {{target}} · {{missing}} left",
    achievedCaption: "achieved",
    contribute: "Contribute",
    adjustContribution: "Adjust contribution",
    insightLabel: "Jerry insight",
    emptyStateTitle: "You have no goals yet",
    emptyStateNewBody: "Create your first goal and let progress do the rest.",
  },
  budget: {
    transactionsPeriod: "Budget activity",
    periodBalance: "Remaining budget",
    transactionsList: "Transactions",
    transactionsByCategory: "By category",
    transactionsLoadError: "Could not load transactions.",
    noTransactionsInPeriod: "No transactions in this period.",
    transactionsCount: "{{count}} transactions",
    uncategorized: "Uncategorized",
    title: "Hey, Budgets!",
    subtitle: "How you are doing vs your limits",
    mostUtilized: "Most utilized budget",
    overLimit: "Over-limit budgets",
    largestOverspend: "Largest overspend",
    newBudget: "New budget",
    editBudget: "Edit budget",
    newBudgetSubtitle: "One monthly limit per category",
    createBudget: "Create budget",
    principalSection: "Main",
    monthlyLimit: "Monthly limit",
    selectCategory: "Select a category",
    alreadyAssigned: " (Already assigned)",
    amountMustBePositive: "Enter an amount greater than 0.",
    saveError: "Could not save the budget. Try again.",
    searchPlaceholder: "Search budget",
    cycleCurrent: "Cycle: Current",
    cycleLast: "Cycle: Previous",
    cycleCustom: "Cycle: Custom",
    sortUsage: "Usage",
    noBudgetUsageYet: "No budget usage yet",
    overLimitValue: "{{count}} budgets exceeded their limit",
    noBudgetsOverLimit: "No budgets over limit",
    noOverspendDetected: "No overspend detected",
    heroRemaining: "You still have {{amount}}",
    heroRemainingPrefix: "You still have",
    heroOfBudget: "left in your budget",
    heroRemainingSubtitle: "left in your budget",
    heroOverspent: "You are over by {{amount}}",
    heroOverspentPrefix: "You are over by",
    heroOverspentContext: "above budget this cycle",
    heroTotalAssigned: "Total assigned budget: <strong>{{amount}}</strong>",
    insightOver_one: "You already went over in {{count}} category",
    insightOver_other: "You already went over in {{count}} categories",
    insightNear: "Some categories are getting close to the limit",
    insightSafe: "Your budget is holding up this month",
    jerryTipLabel: "Jerry's tip",
    allClear: "{{count}} budgets. Everything is within its threshold.",
    emptyStateBody: "Your budgets will show up here once you set a limit for a category.",
    addFirst: "Create Your First Budget",
    listTitle: "What needs attention",
    belowThresholdTitle: "Below threshold",
    viewAll: "View all",
    countLabel: "{{count}} budgets",
    budgetActionsTitle: "Actions for {{name}}",
    budgetActionsHint: "Swipe left or long-press to edit or delete.",
    itemUsage: "You already used {{percent}}%",
    ofLimit: "of",
    itemSpentSummary: "Spent {{range}} · {{detail}}",
    itemOverDetail: "Over by {{amount}}",
    itemNearDetail: "{{amount}} left",
    itemSafeDetail: "{{amount}} left",
    remainingLabel: "left",
    exceededLabel: "over",
    statusInControl: "✓ Below threshold",
    statusNearLimit: "! Near threshold",
    statusExceeded: "✕ Over threshold",
    amountCents: "Cents",
    jerryTipAction: "Assign",
    loadError: "Error loading budgets: {{message}}",
  },
  installments: {
    newInstallmentSubtitle: "Purchase in installments",
    interestRateHelpShort: "Leave it at 0 if there is no interest. You can fill it in later.",
    detailsSection: "Details",
    title: "Hey, Installments!",
    subtitle: "Upcoming charges",
    heroContext: "in upcoming payments",
    heroUpcomingPayments: "Upcoming monthly payments",
    heroOutstandingBold: "Total outstanding debt: <strong>{{amount}}</strong>",
    interestNoteTitle: "Pending interest",
    interestNoteBody: "Some interest rates are missing.",
    accountFilterValue: "Account: {{value}}",
    allAccountsShort: "All",
    filterToolbarLabel: "Search, filter by account and sort installments",
    sortNextAsc: "Next charge ↑",
    sortNextDesc: "Next charge ↓",
    sortNameAsc: "Name A–Z",
    sortNameDesc: "Name Z–A",
    perMonthSuffix: "/mo",
    cardMenuLabel: "More options for {{name}}",
    paidProgress: "{{percent}}% paid",
    heroInsight: "Later on, you have {{amount}} committed",
    heroInsightShort: "Biggest payment hits this week",
    debtByAccountLabel: "By account",
    debtByAccountTitle: "Outstanding debt",
    highestMonthlyPayment: "Highest monthly payment",
    soonestPayoff: "Soonest payoff",
    completedInstallments: "Completed installments",
    activeInstallments: "Active installments",
    editInstallment: "Edit installment",
    newInstallment: "New installment",
    loading: "Loading installments...",
    loadError: "Error loading installments.",
    noActiveInstallments: "No active installments",
    noPayoffDateYet: "No payoff date yet",
    noCompletedInstallments: "No installments completed yet",
    completedCount: "{{count}} installments marked complete",
    installmentsCount_one: "{{count}} installment",
    installmentsCount_other: "{{count}} installments",
    noInstallmentsFound: "No installments found",
    emptyStateBody: "Your upcoming payments will show up here once you add installments.",
    adjustFilters: "Try adjusting your filters or search term",
    tableTitle: "Installments table",
    listTitle: "Your upcoming payments",
    sortedBy: "Sorted by {{label}}.",
    sortByLabel: "Sort by",
    sortPayoffSoon: "soonest payoff",
    sortHighestMonthly: "highest monthly payment",
    sortHighestPending: "highest pending balance",
    itemsCount: "{{count}} items",
    viewAll: "View all",
    allStatuses: "All statuses",
    statusActive: "Active",
    statusCompleted: "Completed",
    statusAll: "All Status",
    tableHeaderInstallment: "Installment",
    tableHeaderOpen: "Open",
    monthly: "Monthly",
    totalAmount: "Total",
    remaining: "Remaining",
    payoff: "Payoff",
    nextCharge: "Next charge",
    payoffDate: "Payoff date",
    progress: "Progress",
    paidLabel: "Paid",
    paidCount: "{{paid}} / {{total}} paid",
    payments: "payments",
    paymentsCount: "{{count}} payments",
    perMonth: "per month",
    allAccounts: "All Accounts",
    accountsSelectedCount: "{{count}} selected",
    searchPlaceholder: "Search by name or merchant...",
    paymentSchedule: "Payment schedule",
    pending: "Pending",
    todayCharge: "Charge: today",
    chargeDate: "Charge: {{date}}",
    chargeDatePending: "Charge pending",
    insightWeekMany: "You have several payments this week",
    insightInstallments: "Most of your payments are installment plans",
    insightMonthHeavy: "Your fixed charges hit harder later this month",
    insightCalm: "Your payments are more spread out by date",
    pressureWeek: "This week you have {{amount}} in payments",
    pressureMonth: "You still have {{amount}} in payments this month",
    pressureLater: "{{amount}} in payments are coming later",
    typeInstallments: "{{count}} payments left",
    remainingPayments: "{{count}} payments remaining",
    remainingShort: "{{amount}} left",
    totalShort: "Total {{amount}}",
    typeFixed: "Fixed payment",
    group: {
      today: "Today",
      week: "This week",
      month: "This month",
      later: "Later",
    },
    coreDetails: "Core details",
    coreDetailsHelp: "Start with the key information so the installment is valid and ready to track.",
    amountsAndTerms: "Amounts and terms",
    amountsAndTermsHelp:
      "Capture balances, installment progress, and supporting details for this installment.",
    notes: "Notes",
    notesHelp: "Add optional context so the installment stays easy to identify and review later.",
    namePlaceholder: "e.g., MacBook Pro M5",
    startDate: "Start date",
    installments: "Installments",
    annualInterestRate: "Annual interest rate (%)",
    interestRateHelp: "Leave blank if you do not know it; enter 0 if it is interest-free.",
    interestRateInvalid: "Enter a number greater than or equal to 0.",
    interestRateMissing: "Rate missing · add it",
    interestRateKnown: "{{rate}} annual",
    totalInterest: "Total interest",
    remainingInterest: "Interest remaining",
    interestUnknown: "Not available",
    initialAmount: "Initial amount",
    donePayments: "Done payments",
    active: "Active",
    createInstallment: "Create installment",
    saveChanges: "Save changes",
    formProgress: "Form progress",
    chat: {
    historyTitle: "History",
    newConversation: "New conversation",
    today: "Today",
    yesterday: "Yesterday",
    independentQuestionsNotice: "Each question is answered separately.",
      trigger: "Ask Jerry",
      triggerShort: "Jerry",
      title: "Ask me about {{domain}}",
      subtitle: "Explore and better understand the information in {{domain}}.",
      intro: "I can help analyze your current {{domain}} data and answer specific questions.",
      suggestionsLabel: "Start with a question",
      askAnotherLabel: "You can also ask",
      suggestionFirst: "Which installment will I finish paying first?",
      suggestionMonthly: "How much do I pay monthly across all installments?",
      suggestionLargest: "Where is my largest outstanding balance?",
      inputLabel: "Question about {{domain}}",
      inputPlaceholder: "Ask another question...",
      keyboardHint: "Enter to send · Shift + Enter for a new line",
      send: "Send question",
    loading: "Reviewing {{domain}}...",
      answerLabel: "Jerry",
      recommendationsLabel: "Recommendations",
      summaryLabel: "Summary",
      retry: "Try again",
      errorValidation: "The question is not valid. Review it and try again.",
      errorProcessing: "The answer could not be processed. Try again.",
      errorUnavailable: "The assistant is temporarily unavailable. Try again in a few minutes.",
      errorNetwork: "The assistant could not be reached. Check your connection and try again.",
      errorUnknown: "The question could not be answered. Try again.",
      domainNames: {
        transactions: "your transactions",
        accounts: "your accounts",
        budgets: "your budgets",
        categories: "your categories",
        tags: "your tags",
        installments: "your installments",
        savings: "your savings",
      },
      domainSuggestions: {
        transactions: {
          first: "What have I spent the most on recently?",
          second: "Which transactions matter most?",
          third: "What patterns do you see in my income and expenses?",
        },
        accounts: {
          first: "Which account has the highest balance?",
          second: "How is my money distributed across accounts?",
          third: "Which account needs the most attention?",
        },
        budgets: {
          first: "Which budget is closest to its limit?",
          second: "Which budget should I adjust first?",
          third: "Where do I still have room available?",
        },
        categories: {
          first: "Which categories do I spend the most on?",
          second: "Which category changed the most this period?",
          third: "How is my income distributed by category?",
        },
        tags: {
          first: "Which tags contain the most expenses?",
          second: "Which tag do I use most often?",
          third: "What patterns do you find across my tags?",
        },
        installments: {
          first: "Which installment will I finish paying first?",
          second: "How much do I pay monthly across all installments?",
          third: "Where is my largest outstanding balance?",
        },
        savings: {
          first: "Which savings goal is closest to completion?",
          second: "How much do I need to save each month?",
          third: "Which savings plan needs the most attention?",
        },
      },
    },
  },
  analytics: {
    viewSummary: "Summary",
    viewCategories: "Categories",
    viewFlow: "Cash flow",
    viewInstallments: "Installments",
    viewSubtitle: {
      summary: "How you're doing this cycle",
      categories: "Which categories your spending goes to",
      flow: "How a category moves month to month",
      installments: "What you owe and pay each month in installments",
    },
    cycleButtonLabel: "Cycle: {{cycle}}",
    cycleMenuLabel: "Choose cycle",
    summaryHeroLabel: "Your cycle summary",
    heroSummary: "You spent {{amount}} this cycle. You used {{percent}}% of your budget.",
    heroSummaryNoBudget: "You spent {{amount}} this cycle.",
    budgetUsedNote: "{{percent}}% used",
    splitSectionTitle: "Where does your spending go?",
    splitSectionSubtitle: "What's committed and what you can still decide",
    splitCommittedNote: "Installments already signed",
    splitPercentOfSpend: "{{percent}}% of spend",
    title: "Analytics",
    subtitle:
      "Understand where your money is going, which categories are pushing you over budget, and what to review first.",
    monthlyReadingLabel: "Monthly financial reading",
    cycleMonthLabel: "Month to analyze",
    cycleCustomMonth: "Other month",
    executiveSummaryLabel: "Executive summary",
    committedSpendLabel: "Cycle spend",
    committedSpendTitle: "Committed vs. discretionary",
    committedSpendSubtitle: "How much of your spending you can still decide on",
    committedLabel: "Committed",
    discretionaryLabel: "Discretionary",
    committedDetail: "Installments already signed · {{percent}}% of spend",
    discretionaryDetail: "What you can still adjust this cycle",
    savedAsideChip: "{{amount}} set aside as savings",
    movementChip: "{{amount}} moved between your accounts",
    reduceDiscretionaryCategory: "Cut {{amount}} from {{category}} to get back on budget",
    discretionaryActionHint: "{{count}} discretionary categories over budget, {{amount}} in total",
    discretionaryOnTrack: "Your discretionary spending is on budget this cycle.",
    unbudgetedSpendHint: "{{amount}} of discretionary spend has no budget assigned.",
    totalExpenseKpi: "Cycle spend",
    totalIncomeKpi: "Cycle income",
    totalBudgetKpi: "Total budget",
    sectionFlowTitle: "This cycle",
    sectionFlowSubtitle: "What moved during the selected period.",
    sectionPositionTitle: "Position",
    sectionPositionSubtitle: "What you hold today, regardless of the cycle.",
    windowToDate: "To date",
    visibleTotalLabel: "Visible",
    metricToggleLabel: "Metric to display",
    accountOverviewLabel: "Account overview",
    accountsCount: "{{count}} accounts",
    installmentsOverviewLabel: "Installments overview",
    installmentsCount: "{{count}} installments",
    loading: "Loading analytics...",
    categoryPyramid: "Category Pyramid",
    categoryPyramidSubtitle: "Expenses (left) vs Deposits (right)",
    expenses: "Expenses",
    deposits: "Deposits",
    expenseByCategory: "Expense by category",
    expenseByCategorySubtitle: "Which categories are driving spending this cycle",
    incomeByCategory: "Income by category",
    incomeByCategorySubtitle: "Which categories are driving income this cycle",
    expenseByAccount: "Expense by account",
    expenseByAccountSubtitle: "How total expense is distributed across your accounts",
    incomeByAccount: "Income by account",
    incomeByAccountSubtitle: "How total income is distributed across your accounts",
    expenseMetric: "Expenses",
    incomeMetric: "Income",
    installmentsByPending: "Installments by pending amount",
    installmentsByPendingSubtitle: "Which installments still carry the largest remaining balance",
    installmentsChartTitle: "Installments",
    installmentsChartSubtitle: "Pending balances and monthly payments in one view",
    installmentInterestPendingLabel: "Interest still owed",
    installmentInterestPendingSubtitle: "Interest included in your outstanding installments",
    installmentInterestPendingUnknown: "Incomplete rates",
    installmentsListTitle: "Installments feeding both charts",
    installmentsListSubtitle: "Select an installment to remove or restore it in its chart.",
    activeInstallmentsChart: "Remaining balance",
    activeInstallmentsChartSubtitle: "How much is still left to pay on each incomplete installment",
    monthlyInstallmentsChart: "Monthly payment",
    monthlyInstallmentsChartSubtitle: "How much you pay each month for each incomplete installment",
    installmentsAmountPair: "{{monthly}} / {{remaining}}",
    installmentsAmountPairLegend: "Monthly payment / remaining balance",
    completedInstallmentsChart: "Completed installments",
    completedInstallmentsChartSubtitle: "Which paid-off installments account for the largest completed totals",
    activeStatusLabel: "Active",
    completedStatusLabel: "Completed",
    noActivity: "No category activity to chart yet.",
    noVisibleCategories: "Select at least one category to show the chart.",
    noVisibleItems: "Select at least one item to show the chart.",
    topIssueLabel: "Top issue",
    topIssueValue: "{{label}}: {{category}} (+{{amount}} over budget)",
    reviewNudge: "Start by reviewing your highest overspending categories",
    reviewNudgeTop: "Start with {{category}}. That is your biggest leak.",
    savingsDistributionEyebrow: "Savings split",
    savingsDistributionTitle: "Savings by institution",
    savingsDistributionSubtitle: "Savings-pocket distribution lives here now so analytics owns allocation view.",
    savingsInstitutionsCount: "{{count}} institutions",
    reviewTopIssueCta: "Review spending in {{category}}",
    noBudget: "No budget",
    nearLimitLabel: "Near limit",
    budgetUsedLabel: "{{percent}}% used",
    budgetUsageValue: "{{percent}}% of budget",
    budgetOfLabel: "of budget",
    overBudgetLabel: "+{{amount}} over budget",
    overBudgetShortLabel: "over budget",
    noBudgetDetailShort: "No guardrail set",
    vsPreviousCycle: "{{change}} vs previous cycle",
    viewDetails: "View details",
    categoryDetailSubtitle: "What happened in this category during the selected period",
    ofSpend: "of spend",
    amountSpent: "Amount spent",
    budgetAlertLabel: "Budget alert",
    budgetSummaryLabel: "Main summary",
    budgetMetric: "Budget",
    overBudgetHeadline: "You are {{amount}} over budget",
    aboveLimitHeadline: "This is {{percent}}% above your limit",
    aboveLimitHeadlineCompact: "+{{percent}}% vs your monthly limit",
    editBudget: "Edit budget",
    setBudget: "Set budget",
    remainingBudget: "Remaining budget",
    remainingBudgetShort: "{{amount}} left",
    overUnderStatus: "Status",
    overBudgetState: "{{amount}} over budget",
    withinBudgetState: "Within budget",
    noBudgetDetail: "This category has spending but no budget guardrail yet.",
    humanOverBudget: "You are {{amount}} over",
    budgetUsageMultiple: "{{multiple}} your budget",
    usedFullBudget: "You used your full budget",
    statusOverBudget: "Over budget",
    statusNearLimit: "Near limit",
    statusInControl: "In control",
    primaryActionLabel: "Main action",
    noLargestChargesAvailable: "Detailed charges are not available for this category yet.",
    loadingLargestCharges: "Loading detailed charges...",
    categoryRankingTitle: "Category ranking",
    categoryRankingSubtitle: "Sort it by whatever you need to review.",
    categoryRankingIncomeSubtitle: "See which categories bring in the most income.",
    rankingSortLabel: "Sort by",
    rankingSort: {
      amount: "Amount",
      overspend: "Overspend",
      variance: "Deviation",
    },
    rankingOverspendMeta: "{{amount}} over budget",
    rankingNoOverspendMeta: "Within budget",
    rankingVarianceMeta: "{{amount}} vs its average",
    rankingNoVarianceMeta: "No baseline",
    openCategoryDetail: "View {{category}} details",
    categoryTrendTitle: "Category monthly flow",
    categoryTrendSubtitle: "Track expense and income across recent months for one category.",
    reviewCategoryDetails: "Review category details",
    categoryTrendSelectLabel: "Category to visualize",
    expenseSeriesLabel: "Expense",
    incomeSeriesLabel: "Income",
    trendRangeLabel: "Window",
    trendRangeValue: "{{count}} months",
    latestExpenseLabel: "Latest expense",
    latestIncomeLabel: "Latest income",
    averageExpenseLabel: "Average expense",
    averageIncomeLabel: "Average income",
    categoryTrendEmptySeries: "No movement found for the selected category in this 6-month window.",
    categoryWatchlistTitle: "Category watchlist",
    categoryWatchlistSubtitle: "Spend, overage or remaining amount, and direct access to details.",
    accountsOverline: "Accounts",
    kindLabel: "Type",
    flowSeriesLabel: "Series",
    flowSeriesBoth: "Both",
    toggleSeriesHide: "Remove {{name}} from chart",
    toggleSeriesShow: "Show {{name}} in chart",
    incompleteRatesTitle: "Incomplete rates",
    incompleteRatesText: "Rates are still missing to calculate the pending interest on your installments.",
    hiddenFromChart: "Hidden from chart",
    hiddenCountRestore: "{{count}} hidden · Restore",
    driversTitle: "What's driving this?",
    driversSubtitle: "Calculated insights about why this category moved",
    driverSingleLargePurchase: "{{amount}} was one big purchase in this category",
    driverLargePurchaseConcentration:
      "Most of your spending comes from {{count}} large purchases",
    driverManySmallPurchases: "You made {{count}} small purchases in this category",
    driverWeekendSpike: "{{percent}} of this category happened on weekends",
    driverRecentSpike: "{{percent}} of this category happened in the last 3 days",
    driverSinglePurchaseFallback: "This category was driven by one purchase",
    driverPurchaseCountFallback: "You made {{count}} purchases with an average of {{average}}",
    suggestedActionsTitle: "Suggested actions",
    driverActionReviewLargest: "Review your largest transactions",
    driverActionSetStricterBudget: "Consider setting a stricter budget",
    driverActionLimitWeekend: "Limit spending on weekends",
    driverActionReviewRecent: "Review recent activity",
    modalInsightTopOverspend: "This category drives the largest overspend this cycle",
    modalInsightAboveBudget: "Spending is {{percent}}% above budget",
    modalInsightBudgetUsage: "You have already used {{percent}}% of your budget",
    modalInsightShareOfSpend: "It represents {{percent}}% of total spend",
    noDetailedTransactionsInsight:
      "No detailed transactions are available for this category, but the aggregated spend comes from the period summary.",
    transactionsTitle: "Transactions",
    transactionsSubtitle: "Current period activity in this category",
    topChargesShareSummary: "Your top 3 charges represent {{percent}}% of this category",
    topChargeBadge: "Top {{rank}}",
    loadingShort: "Loading...",
    noTransactionsForCategory: "No individual transactions to show yet.",
    noTransactionsForCategoryDetail:
      "The total shown comes from aggregated period data.",
    notAvailable: "Not available",
    saveBudgetError: "Couldn't save budget right now.",
  },
  transactionModal: {
    sections: {
      principal: "Principal",
      context: "Context",
      optional: "Optional",
    },
    hints: {
      required: "Required",
      optional: "Optional",
    },
    amountCents: "Cents",
    quickTitle: "Quick transaction",
    quickSubtitle: "Record an expense in a few steps.",
    createQuick: "Create transaction",
    quickNamePlaceholder: "e.g., Supermarket",
    quickAmountPlaceholder: "0.00",
    quickNoCategory: "No category",
    quickSelectAccount: "Select an account",
    quickValidationError: "Please complete name, amount, date, and account.",
    quickSubmitError: "Could not create transaction. Please try again.",
    newTitle: "New transaction",
    editTitle: "Edit transaction",
    subtitle: "Add a transaction to track your spending or income",
    coreDetails: "Core details",
    coreDetailsHelp: "Tune the required fields first so the movement stays valid and complete.",
    context: "Context",
    contextHelp: "Optional fields help classify or link the movement without being required to save it.",
    additionalDetails: "Additional details",
    additionalDetailsHelp: "Attach a receipt or leave notes so the movement stays easy to audit later.",
    transactionNamePlaceholder: "e.g., Netflix, Grocery shopping",
    loadingTypes: "Loading types...",
    selectTransactionType: "Select transaction type",
    loadingAccounts: "Loading accounts...",
    accountsAvailable: "{{count}} available",
    noAccountsAvailable: "No accounts available",
    selectAccount: "Select an account",
    noAccountsFound: "No accounts found. Please create an account first.",
    selectDestinationAccount: "Select a destination account",
    noDestinationAccountsAvailable: "No destination accounts available",
    noDestinationAccountsFound: "No destination accounts available. Choose a different origin account.",
    selectCategory: "Select a category",
    loadingTags: "Loading tags...",
    noTagsAvailable: "No tags available",
    selectTag: "Select a tag",
    allocateSavingPlan: "Allocate to a saving plan",
    unlinkSavingPlan: "Unlink saving plan",
    linkInstallment: "Link to an installment",
    unlinkInstallment: "Unlink installment",
    attachReceipt: "Attach receipt",
    removeAttachment: "Remove attachment {{name}}",
    chooseFile: "Choose file",
    fileFormats: "JPG, PNG, PDF, DOC (max 30MB)",
    descriptionPlaceholder: "Add any extra details about this transaction...",
    descriptionHelp: "Optional - add any extra details",
    mobileContextTitle: "Context",
    failedProcessFile: "We couldn't process that file. Please try another image.",
    enterTransactionName: "Please enter a transaction name",
    enterValidAmount: "Please enter a valid amount",
    selectAccountError: "Please select an account",
    selectDestinationError: "Please select a destination account",
    destinationMustDiffer: "Destination account must be different from the origin account",
    selectDateError: "Please select a date",
    updateTransaction: "Update transaction",
    createTransaction: "Create transaction",
  },
  router: {
    notFoundTitle: "Route not found",
    notFoundBody: "If you landed here, the path does not match any route defined in router.",
  },
  terms: {
    home: "Back to Hey Jerry",
    title: "Terms and Conditions",
    updated: "Last updated: August 20, 2026",
    intro: "These Terms and Conditions explain the rules for using Hey Jerry, a personal finance workspace for recording, organizing, and understanding your own financial activity.",
    sections: {
      service: {
        title: "1. The service",
        body: "Hey Jerry helps you record transactions, organize accounts and categories, compare periods, and track plans such as budgets, savings goals, and installments. It does not connect to your bank, store bank credentials, move money, or make payments.",
      },
      eligibility: {
        title: "2. Eligibility",
        body: "You may use Hey Jerry only if you can form a binding agreement under the laws that apply to you. If you use the service for an organization, you confirm that you are authorized to accept these terms for it.",
      },
      account: {
        title: "3. Your account",
        body: "You are responsible for the information you provide, keeping your credentials confidential, and all activity carried out through your account. Tell us promptly if you believe your account has been used without permission.",
      },
      data: {
        title: "4. Your data",
        body: "You retain responsibility for the financial information you enter. You give Hey Jerry permission to process that information only as needed to provide, secure, maintain, and improve the service. Do not enter information you are not allowed to use.",
      },
      use: {
        title: "5. Acceptable use",
        body: "Do not misuse the service, interfere with its operation, attempt unauthorized access, upload malicious code, or use it to violate another person’s rights or the law. Do not treat sample figures or generated summaries as verified financial records.",
      },
      availability: {
        title: "6. Availability and changes",
        body: "Hey Jerry may change, suspend, or discontinue features to maintain or improve the service. We will make reasonable efforts to communicate material changes when practical, but uninterrupted availability is not guaranteed.",
      },
      intellectualProperty: {
        title: "7. Intellectual property",
        body: "Hey Jerry and its software, interface, brand, and original content belong to their respective owners. These terms give you a limited, personal, non-transferable right to use the service while your account is allowed to access it.",
      },
      privacy: {
        title: "8. Privacy",
        body: "Our handling of personal information is described in the applicable privacy notice. When enabled, Hey Jerry uses PostHog as a product analytics provider to understand navigation and feature adoption. This analytics uses only an internal identifier and low-cardinality dimensions; it does not send amounts, balances, transaction names, prompts, responses, email, phone, tokens, or API payloads. The SDK does not use autocapture or session replay and respects Do Not Track. These terms do not replace the privacy notice; review both documents before creating an account.",
      },
      disclaimer: {
        title: "9. No financial advice",
        body: "Hey Jerry provides organizational and informational tools, not financial, investment, tax, legal, or accounting advice. Check important decisions and records with a qualified professional or the original source.",
      },
      liability: {
        title: "10. Liability",
        body: "To the extent permitted by law, Hey Jerry is not responsible for losses caused by your decisions, inaccurate information you enter, interruptions outside our reasonable control, or your failure to protect your account.",
      },
      termination: {
        title: "11. Ending access",
        body: "You may stop using your account at any time. We may restrict or end access when necessary to protect the service, comply with law, address misuse, or respond to a material breach of these terms.",
      },
      changes: {
        title: "12. Changes to these terms",
        body: "We may update these terms as the service changes or legal requirements evolve. The updated version will show a new date. Continued use after an update means you accept the updated terms where the law allows.",
      },
      contact: {
        title: "13. Questions",
        body: "If you have a question about these terms or your account, use the support channel provided with your Hey Jerry account.",
      },
    },
  },
  landing: {
    nav: {
      aria: "Main navigation",
      sections: "Sections",
      home: "Hey Jerry, home",
      why: "Why Jerry",
      how: "How it works",
      faq: "Questions",
      signIn: "Sign in",
      signUp: "Create account",
    },
    hero: {
      eyebrow: "Personal finance",
      titleLine1: "Give your money",
      titleLine2: "meaning.",
      lead: "Jerry does not sync with your bank, and that is on purpose. You record your transactions; Jerry organizes them, compares periods, and gives you a full reading of your month.",
      primaryCta: "Start with Jerry",
      secondaryCta: "See how it works",
      previewAria: "Preview of the Jerry dashboard",
      previewCaption: "Sample view",
    },
    preview: {
      sampleData: "Sample data",
      window: "Dashboard",
      balanceLabel: "Balance this period",
      balanceValue: "$13,766",
      balanceMeta: "Compared with the previous period",
      inflowLabel: "Inflow",
      inflowValue: "$28,400",
      outflowLabel: "Outflow",
      outflowValue: "$14,634",
      breakdownLabel: "Where it concentrated",
      rows: {
        installments: "Installments",
        food: "Food",
        transport: "Transport",
      },
    },
    manifesto: {
      title: "Understanding your spending means understanding your decisions.",
      body: "An app that imports everything for you hands over a history you never read. Jerry asks for one small gesture, recording, and every number in your month carries a story you actually remember.",
      benefits: {
        one: {
          title: "All your money in one place",
          copy: "Accounts, transactions, categories, and tags. Jerry computes balances and cross-references them into one view of the month.",
        },
        two: {
          title: "Period comparisons with evidence",
          copy: "Jerry compares periods and distributions to show what changed, without inventing causes your data cannot explain.",
        },
        three: {
          title: "Plans you can actually track",
          copy: "Budgets, savings goals, and installments, measured against the transactions you record.",
        },
      },
    },
    process: {
      title: "From transaction to decision.",
      body: "Jerry organizes what happened, compares periods, and highlights what is worth reviewing. The next move is yours.",
      steps: {
        one: { kicker: "You record", title: "Transactions", copy: "Accounts, purchases, income, and installments." },
        two: { kicker: "Jerry compares", title: "Signals", copy: "Balances, concentrations, and changes across periods." },
        three: { kicker: "You decide", title: "Actions", copy: "What to adjust, prioritize, or keep watching." },
      },
    },
    insight: {
      title: "Your data becomes a clearer reading.",
      body: "Jerry puts balances, changes, and progress up front so you can decide calmly.",
      allocationLabel: "Period allocation",
      segments: {
        income: "Available",
        fixed: "Installments",
        flex: "Variable",
      },
      decisions: {
        one: "How much came in, went out, and stayed in the period",
        two: "Which categories and tags concentrate the movement",
        three: "How your budgets, goals, and installments are progressing",
      },
    },
    faq: {
      title: "Questions before you start.",
      body: "What Jerry does today, what depends on your data, and where its limits are.",
      items: {
        banks: {
          question: "Does Jerry connect to my bank automatically?",
          answer:
            "No, and that is a design decision. You create your accounts and record your transactions inside Jerry. The important side effect: Jerry never asks for or stores your bank credentials, because it does not need them.",
        },
        analysis: {
          question: "What can Jerry analyze with confidence?",
          answer:
            "The data you record: balances, inflow, outflow, period-over-period changes, distribution by account, category, or tag, and progress on budgets, savings goals, and installments. With enough history it also shows comparisons across periods.",
        },
        advice: {
          question: "Does Jerry tell me what to do?",
          answer:
            "No. Jerry highlights changes and areas worth reviewing; the decision is yours. Jerry supports decisions, it does not replace financial advice.",
        },
        taxonomy: {
          question: "What is the difference between categories and tags?",
          answer:
            "A category explains what the transaction was and is used to group spending or set a budget, for example Restaurants or Transport. A tag adds cross-cutting context, for example Work trip, Reimbursable, or Installments. So a purchase can sit in Restaurants and carry the Work trip tag.",
        },
        autoCategorize: {
          question: "Does Jerry categorize my transactions on its own?",
          answer:
            "No. You pick the category and, if useful, a tag when you record or edit each transaction. Jerry uses that organization to compute distributions and spot concentrations.",
        },
        money: {
          question: "Can Jerry move money or pay my installments?",
          answer:
            "No. Jerry is for recording, organizing, analyzing, and tracking. It does not execute transfers, charges, or payments, and it makes no changes to your bank accounts.",
        },
      },
    },
    finalCta: {
      kicker: "Your money, clearer starting today",
      title: "Make room for better decisions.",
      body: "Start by recording one account. The rest builds itself from your own month.",
      cta: "Create my account",
    },
    footer: {
      tagline: "Personal finance for deciding with clarity.",
      dataNote: "Jerry does not connect to your bank or store bank credentials.",
      terms: "Terms and Conditions",
      language: "Language",
      theme: "Theme",
      themeLight: "Light",
      themeDark: "Dark",
    },
  },
};
